<template> 
	<main class="app-main">
		<div v-if="product" :class="productContainerClass"> 
			<div class="product__left-panel">
                <div class="item inside-item item--style-2" data-animation-path-duration="1500" data-animation-path-easing="easeOutElastic" data-morph-path="M 418.1,159.8 C 460.9,222.9 497,321.5 452.4,383.4 417.2,432.4 371.2,405.6 271.3,420.3 137.2,440 90.45,500.6 42.16,442.8 -9.572,381 86.33,289.1 117.7,215.5 144.3,153.4 145.7,54.21 212.7,36.25 290.3,15.36 373.9,94.6 418.1,159.8 Z" data-path-scaleY="1.1" data-image-scaleX="1.3" data-image-scaleY="1.3" data-animation-deco-duration="2000" data-animation-deco-delay="100" data-deco-rotate="-10"> 
                        
    				<div :class="productClass">
                        
                        <img :data-item-image="product.image" :src="product.image" class="img-responsive" alt="Product" />
                         
                        <div class="product__bottom product__deta-btn">
                            <a target="_blank" id="d" :href="product.redirect_to" class="btn product__bottom--button">                  
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="28" viewBox="0 0 32 28"><defs><path id="a" class="product__shape" d="M1064.97 590.08l-2.41 11.38c-.12.6-.67 1.04-1.3 1.04h-18.41l.67 3.5h16.44c.64 0 1.15.43 1.3.99a3.49 3.49 0 0 1-2.48 6.01 3.53 3.53 0 0 1-3.56-3.5c0-.61.17-1.22.48-1.75h-8.07c.32.53.48 1.14.48 1.75 0 1.93-1.59 3.5-3.55 3.5a3.53 3.53 0 0 1-3.56-3.5c0-.91.35-1.73.92-2.35l-3.88-20.4h-4.37a.66.66 0 0 1-.67-.66v-.43c0-.37.3-.66.67-.66h4.74c.64 0 1.19.45 1.31 1.07l.46 2.43h23.49c.84 0 1.47.77 1.3 1.58zm-20.41 17.67c-.98 0-1.78.79-1.78 1.75s.8 1.75 1.78 1.75 1.77-.79 1.77-1.75-.79-1.75-1.77-1.75zm16 1.75c0-.96-.8-1.75-1.78-1.75s-1.78.79-1.78 1.75.8 1.75 1.78 1.75 1.78-.79 1.78-1.75zm2.56-19.25h-22.6l2 10.5h18.38z"/></defs><g transform="translate(-1033 -585)"><use xlink:href="#a"/></g></svg>
                                Купи онлайн
                            </a>
                        </div>
    				</div>
                    <svg class="item__svg" width="500px" height="500px" viewBox="0 0 500 500">
                        <clipPath id="clipShape2">
                            <path class="item__clippath" d="M 378.1,121.2 C 408.4,150 417.2,197.9 411,245.8 404.8,293.7 383.5,341.7 353.4,370.7 303.2,419.1 198.7,427.7 144.5,383.8 86.18,336.5 67.13,221.3 111.9,161 138.6,125 188.9,99.62 240.7,90.92 292.4,82.24 345.6,90.32 378.1,121.2 Z" />
                        </clipPath>
                        <g clip-path="url(#clipShape2)">
                            <path d="M0,0h600v600H0V0z"/>
                        </g>
                    </svg> 
                </div>
			</div>
			<div class="product__right-panel">
				<div class="product__description">
					<div class="product__first-section">
						<div class="product__first-section--content">
							<div class="product__titles">
								<h1 class="product__big-title" v-bind:data-item-name="product.title" v-text="product.title"></h1>
								<h3 class="product__sub-title" v-text="product.sub_title"></h3>
							</div>
							<div class="product__content">
								<p class="product__description--text" v-html="product.short_description"></p>
								<div class="product__bottom">
									<div class="product__bottom--details" @click="detailClicked()">Детайлно описание
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="10" viewBox="0 0 22 10">
                                            <g transform="translate(-959 -595)">
                                                <path id="b" d="M981 595.62a.64.64 0 0 0-.05-.24.77.77 0 0 0-.69-.38.8.8 0 0 0-.53.18l-9.81 8.31-9.67-8.2a.8.8 0 0 0-.52-.18c-.2 0-.37.06-.51.18a.55.55 0 0 0-.22.45c0 .17.07.32.22.44l10.19 8.64c.14.12.31.18.51.18.21 0 .38-.06.52-.18l10.34-8.76a.56.56 0 0 0 .17-.21.68.68 0 0 0 .05-.23z"/>
                                            </g>
                                        </svg>
                                    </div>
									<a target="_blank" id="detail" :href="product.redirect_to" class="btn product__bottom--button">					
										<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="28" viewBox="0 0 32 28"><defs><path id="a" class="product__shape" d="M1064.97 590.08l-2.41 11.38c-.12.6-.67 1.04-1.3 1.04h-18.41l.67 3.5h16.44c.64 0 1.15.43 1.3.99a3.49 3.49 0 0 1-2.48 6.01 3.53 3.53 0 0 1-3.56-3.5c0-.61.17-1.22.48-1.75h-8.07c.32.53.48 1.14.48 1.75 0 1.93-1.59 3.5-3.55 3.5a3.53 3.53 0 0 1-3.56-3.5c0-.91.35-1.73.92-2.35l-3.88-20.4h-4.37a.66.66 0 0 1-.67-.66v-.43c0-.37.3-.66.67-.66h4.74c.64 0 1.19.45 1.31 1.07l.46 2.43h23.49c.84 0 1.47.77 1.3 1.58zm-20.41 17.67c-.98 0-1.78.79-1.78 1.75s.8 1.75 1.78 1.75 1.77-.79 1.77-1.75-.79-1.75-1.77-1.75zm16 1.75c0-.96-.8-1.75-1.78-1.75s-1.78.79-1.78 1.75.8 1.75 1.78 1.75 1.78-.79 1.78-1.75zm2.56-19.25h-22.6l2 10.5h18.38z"/></defs><g transform="translate(-1033 -585)"><use xlink:href="#a"/></g></svg>
										Купи онлайн
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="product__second-section">
						<div class="product__content">
                            <h1 class="product__detail-title">Детайлно описание</h1>
							<div class="product__description" v-html="product.description"></div>
						</div>
                        <section v-if="product && product.certificates" v-html="this.$root.$data.settings.certificates" class="certificates"></section>
                        <Articles v-if="product.articles && product.articles.length" :articles="product.articles"></Articles>
					</div>
				</div>
			</div>
		</div>
		<div v-if="settings" class="product__footerbar">
			<h3 class="product__footerbar--title" v-html="settings.footer_title"></h3>
			<p class="product__footerbar--text" v-html="settings.footer_description"></p>
		</div>
	</main>
</template>

<script>
import Product from '@/services/product'
import WindowService from '@/services/window'

import Articles from './articles'

import AnimeModule from '@/modules/animejs'

export default {
    name: 'InsideProduct',
    components: { Articles },
    data () {
        return {
            product: { title: '', description: '' },
            settings: null,
            error: null
        }
    },
    head () {
        return {
            title: {
                inner: 'Bimbi',
                complement: this.product.title
            },
            meta: [
                { name: 'description', content: this.product.description }
            ]
        }
    },
    beforeCreate () {
        this.$emit('updateHead')
    },
    computed: {
        productContainerClass: function () {
            return {
                'product': true,
                'product__inside': true,
                [this.product.theme]: true
            }
        },
        productClass: function () {
            return {
                'product__image': true,
                'product__inside--image': true
            }
        },
        convertHtmlToText () {
            let inputText = this.product.short_description
            let returnText = '' + inputText
            returnText = returnText.replace(/<br>/gi, '\n')
            returnText = returnText.replace(/<br\s\/>/gi, '\n')
            returnText = returnText.replace(/<br\/>/gi, '\n')
            returnText = returnText.replace(/<p.*>/gi, '\n')
            returnText = returnText.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, '$2 ($1)')
            returnText = returnText.replace(/<script.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/script>/gi, '')
            returnText = returnText.replace(/<style.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/style>/gi, '')
            returnText = returnText.replace(/<(?:.|\s)*?>/g, '')
            returnText = returnText.replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, '\n\n')
            returnText = returnText.replace(/ +(?= )/g, '')
            returnText = returnText.replace(/&nbsp;/gi, '')
            returnText = returnText.replace(/&amp;/gi, '&')
            returnText = returnText.replace(/&quot;/gi, '"')
            returnText = returnText.replace(/&lt;/gi, '<')
            returnText = returnText.replace(/&gt;/gi, '>')
            return returnText
        }
    },
    methods: {
        onScroll: function () {
            let productImage = document.querySelector('.product__image')
            let firstSection = document.querySelector('.product__first-section')
            let secondSection = document.querySelector('.product__second-section')

            let detail = document.getElementById('detail').offsetTop
            let detBtn = document.querySelector('.product__deta-btn')

            if (WindowService.scrollTop() >= detail) {
                this.isSmall = true
                WindowService.addClassToElement(productImage, 'product__inside--image__small')
                WindowService.addClassToElement(firstSection, 'product__first-section--auto-height')
                WindowService.addClassToElement(secondSection, 'product__second-section--auto-height')

                detBtn.style.display = 'block'
            } else {
                WindowService.removeClassFromElement(productImage, 'product__inside--image__small')
                WindowService.removeClassFromElement(firstSection, 'product__first-section--auto-height')
                WindowService.removeClassFromElement(secondSection, 'product__second-section--auto-height')

                detBtn.style.display = 'none'
            }
        },
        detailClicked: function () {
            const detail = document.getElementById('detail')
            detail.scrollIntoView()
        },
        initAnimation: function () {
            let item = document.querySelectorAll('.inside-item')
            this.$nextTick(function () {
                item = document.querySelectorAll('.inside-item')
                console.log(item)
                return new AnimeModule(item[0])
            })
        }
    },
    mounted: function () {
        if (this.$root.$data && this.$root.$data.settings) this.settings = this.$root.$data.settings
        Product.getById(`${this.$root.$data.baseUrl}/products`, this.$route.params.id)
            .then(res => {
                if (res.success) {
                    this.product = res.data
                    this.$emit('updateHead')
                }
            })
            .catch(err => console.log(err))

        let button = document.querySelectorAll('.product__bottom--button')
        Array.prototype.map.call(button, function (x) {
            x.addEventListener('click', function () {
                window.fbq('track', 'AddToCart')
            }, false)
        })
    },
    created: function () {
        WindowService.addEvent('scroll', this.onScroll)
        this.initAnimation()
    },
    beforeRouteUpdate: function beforeRouteUpdate (to, from, next) {
        Product.getById(`${this.$root.$data.baseUrl}/products`, this.$route.params.id)
            .then(res => {
                if (res.success) {
                    this.product = res.data
                    this.$emit('updateHead')
                }
            })
            .catch(err => console.log(err))
        next()
    },
    beforeDestroy: function () {
        WindowService.removeEvent('scroll', this.onScroll)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/InsideProduct.vue?61a80c81